import './App.css'
import Portfolio from './components/Portfolio'

const App = () => (
  <div className="pf-bg-container">
    <Portfolio />
  </div>
)

export default App